import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SingleSelectStepProps, RefDataType } from 'scenes/common/types';
import { OptionImage, SubmitButton } from 'components';

import SelectQuestion from 'scenes/common/components/Questions/SelectQuestion';
import IMAGES from 'components/images';
import { SelectOptions } from '../../Questions';

export const STATE_KEY = 'roofMaterial';
export const ROOF_MATERIAL = 'roofMaterial';
export const QUESTION = 'What is the main material the roof is made of?';

export const ROOF_IMAGE_MAP: Record<string, string | undefined> =
  IMAGES.ROOF_MATERIALS;

const headingFromSelection = (
  options: SelectOptions,
  lookupValue: string
): string => {
  const selectedOption: RefDataType = options.find(
    (option) => (option as RefDataType).value === lookupValue
  ) as RefDataType;
  return selectedOption?.label ?? '';
};

const RoofMaterialStep: FunctionComponent<Pick<
  SingleSelectStepProps,
  'defaultStateValue' | 'onNext' | 'options'
>> = ({ onNext, defaultStateValue, options }) => {
  const {
    formState: { isValid },
    handleSubmit,
    control,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const roofType: string = watch(STATE_KEY, defaultStateValue);
  const image = ROOF_IMAGE_MAP[roofType];

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        question={QUESTION}
        options={options}
        control={control}
        isLoading={false}
        stateKey={STATE_KEY}
        defaultValue={defaultStateValue}
        ariaRequired
      />
      {image && (
        <OptionImage
          src={image}
          heading={headingFromSelection(options, roofType)}
        />
      )}
      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default RoofMaterialStep;
